import * as fs from 'fs';
import * as https from 'https';

import React from 'react';

export const BASE_AWS_API_URL = process.env.NODE_ENV === 'production' ? '#{BASE_AWS_API_URL}' : 'https://api.claytonhomes.itg.cct-pubweb.com/';
export const BASE_API_URL = process.env.NODE_ENV === 'production' ? '#{BASE_API_URL}' : 'https://dev.cmhinfo.biz/WebServices2/api/';
export const ENVIRONMENT = process.env.NODE_ENV === 'production' ? '#{terraformEnvCode}' : "dev";
export const LAMBDA_TOKEN = '#{lambda_token}';

export const getBaseAwsApiUrl = () => {
    return BASE_AWS_API_URL;
};

export const getBaseApiUrl = () => {
    return BASE_API_URL;
};

export const FS_DEV_EXISTS = (typeof fs.readFileSync !== 'undefined');

export const getCertAgent = () => {
    return ((ENVIRONMENT === "dev" || ENVIRONMENT === "itg" || ENVIRONMENT === "qua") && FS_DEV_EXISTS) ? 
    new https.Agent({ ca: fs.readFileSync(`./ClaytonRootCA.cer`), keepAlive: false })
    : null;
}